import React from 'react'
import Layout from './src/components/Layout/Layout'
import Scripts from './src/components/Layout/Scripts'

export const wrapPageElement = ({ element }) => {
    return (
        <>
            <Scripts />
            <Layout>
                {element}
            </Layout>
        </>
    )
}